/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { FC, useEffect, useState } from 'react';
import { ClientStatisticsReportReference } from '@DigitaleDoerfer/digitale-doerfer-api';
import StatisticsView from './Statistics.view';
import { getStatisticsReferences } from './Statistics.actions';

const StatisticsContainer: FC = () => {
	const [statisticsReferences, setStatisticsReferences] = useState<ClientStatisticsReportReference[]>([]);

	useEffect(() => {
		getStatisticsReferences()
			.then(result => setStatisticsReferences(result))
			.catch(error => console.log(error));
	}, []);

	return <StatisticsView statisticsReferences={statisticsReferences} />;
};

export default StatisticsContainer;
